/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 14.5327H16" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7 21H17C19.2091 21 21 19.2091 21 17V10C21 7.79086 19.2091 6 17 6H14.6569C13.596 6 12.5786 5.57857 11.8284 4.82843L11.1716 4.17157C10.4214 3.42143 9.40401 3 8.34315 3H7C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
